import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import TextInput from "components/Form/components/TextInput";
import Submit from "components/Form/components/Submit";
import { fetch as router } from "helpers/router";
import validationSchema from "./validation";
import MFAInput from "../../MFAInput";

const LoginForm = ({ onSubmit, requiresMfa, isRefreshing = false }) => {
  const {
    register,
    handleSubmit,
    formState: {
      errors, isValid, isSubmitting, isSubmitSuccessful,
    },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const formContext = { isValid, isSubmitting, isSubmitSuccessful };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form">
      {!requiresMfa ? (
        <>
          <div className="form-row">
            <div className="form-group">
              <div className="form-col">
                <TextInput
                  register={register}
                  name="email"
                  id="login_email"
                  label="email"
                  error={errors.email}
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <div className="form-col">
                <TextInput
                  register={register}
                  name="password"
                  id="login_password"
                  label="password"
                  type="password"
                  error={errors.password}
                />
              </div>
            </div>
          </div>

          <div className="form-row">
            <a
              href={router("auth.password.reset.index")}
              className="forgot-password"
              target="_blank"
              rel="noreferrer"
              style={{ textAlign: "right" }}
            >
              forgot password?
            </a>
          </div>
        </>
      ) : (
        <div className="form-row">
          <div className="form-group">
            <div className="form-col">
              <MFAInput {...register("mfaCode")} />
            </div>
          </div>
        </div>
      )}
      <div className="form-row">
        <div className="form-group">
          <div className="form-col" style={{ marginBottom: 0 }}>
            <Submit formContext={formContext} value="Log in" disabled={isRefreshing} />
          </div>
        </div>
      </div>
    </form>
  );
};

export default LoginForm;
